var Immutable = require('immutable');
var KEY_SEPARATOR = '-';
var Redux = require('react-redux')
var { syntaxRef } = require('../../Blocks/CodeBlock')
function PrismDecorator(options = {}) {
    const user = Redux.useSelector((state) => state.auth.user)
    this.options = Immutable.Map(options)
    this.highlighted = {};
    this.user = user
}

/**
 * Return list of decoration IDs per character
 *
 * @param {ContentBlock}
 * @return {List<String>}
 */
PrismDecorator.prototype.getDecorations = function(block) {
    var tokens, token, tokenId, resultId, offset = 0, tokenCount = 0;
    var filter = this.options.get('filter');
    var getSyntax = this.options.get('getSyntax');
    var blockKey = block.getKey();
    var blockText = block.getText();
    var blockTheme = this.user['theme'] === 'Light' ? 'light' : 'dark'
    var decorations = Array(blockText.length).fill(null);
    var Prism = this.options.get('prism');
    var highlighted = this.highlighted;

    highlighted[blockKey] = {};

    if (!filter(block)) {
        return Immutable.List(decorations);
    }

    var syntax = getSyntax(block) || this.options.get('defaultSyntax');

    // Allow for no syntax highlighting
    if (syntax == null || syntax === 'plain') {
        return Immutable.List(decorations);
    }

    // Parse text using Prism
    let language
    try {
        language = require(`prismjs/components/prism-${syntaxRef[syntax]}`)
    } catch {
        if([])
        console.log('language not found')
    }
    let grammar = Prism.languages[syntaxRef[syntax]]
    if(!grammar){
        return Immutable.List(decorations);
    }
    tokens = Prism.tokenize(blockText, grammar);


    function processToken(decorations, token, offset) {
    if (typeof token === 'string') {
        return
    }
        //First write this tokens full length
        tokenId = 'tok'+(tokenCount++);
        resultId = `${blockKey}-${tokenId}-${blockTheme}`;
        highlighted[blockKey][tokenId] = token;
        occupySlice(decorations, offset, offset + token.length, resultId);
        //Then recurse through the child tokens, overwriting the parent
        var childOffset = offset;
        for (var i =0; i < token.content.length; i++) {
            var childToken = token.content[i];
            processToken(decorations, childToken, childOffset);
            childOffset += childToken.length;
        }
    }

    for (var i =0; i < tokens.length; i++) {
        token = tokens[i];
        processToken(decorations, token, offset);
        offset += token.length;
    }

    return Immutable.List(decorations);
};

/**
 * Return component to render a decoration
 *
 * @param {String}
 * @return {Function}
 */
PrismDecorator.prototype.getComponentForKey = function(key) {
    return this.options.get('render');
};

/**
 * Return props to render a decoration
 *
 * @param {String}
 * @return {Object}
 */
PrismDecorator.prototype.getPropsForKey = function(key) {
    var parts = key.split('-');
    var blockKey = parts[0];
    var tokId = parts[1];
    var theme = parts[2]
    var token = this.highlighted[blockKey][tokId];

    return {
        type: token.type,
        theme: theme
    };
};

function occupySlice(targetArr, start, end, componentKey) {
    for (var ii = start; ii < end; ii++) {
        targetArr[ii] = componentKey;
    }
}

export default PrismDecorator;